import React from "react";
import { PurchaseSubscriptionComponent } from "./purchase-subscription.component";

export const PurchaseSubscriptionPage = () => <PurchaseSubscriptionComponent />;
